import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "./ui/button";
import { cn, shortenName } from "../../utils/helper-funcs";

interface RacerCarouselProps {
  onFocusNextRacer: () => void;
  onFocusPrevRacer: () => void;
  disableControls: boolean;
  currentHorse: string;
}

export function RacerCarousel({
  onFocusNextRacer,
  onFocusPrevRacer,
  disableControls,
  currentHorse,
}: RacerCarouselProps) {
  return (
    <div className="flex items-center gap-2 racer-carousel">
      <Button
        disabled={disableControls}
        className="px-2 text-foreground disabled:cursor-not-allowed disabled:text-muted-foreground"
        onClick={onFocusPrevRacer}
        size={"icon"}
        variant={"ghost"}
      >
        <ChevronLeft />
      </Button>
      <div>
        <p
          className={cn(
            "text-xs sm:text-sm md:text-base font-semibold w-20 sm:w-24 text-center",
            disableControls ? "text-muted-foreground" : "text-foreground",
          )}
        >
          {!currentHorse.length ? "Cycle Camera" : shortenName(currentHorse)}
        </p>
      </div>
      <Button
        disabled={disableControls}
        className="px-2 text-foreground disabled:cursor-not-allowed disabled:text-muted-foreground"
        onClick={onFocusNextRacer}
        size={"icon"}
        variant={"ghost"}
      >
        <ChevronRight />
      </Button>
    </div>
  );
}